module.exports = __webpack_public_path__ + "static/media/Sucrose.448bc697.png";